import React from "react";
import { CustomerPortalCustomerAddressInfo } from "../../../common/models";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { Box } from "../../../components";
import { oneLineAddress } from "../../../helpers/addressesHelpers";

interface Props {
  addresses: CustomerPortalCustomerAddressInfo[];
  invoiceAddressId?: string;
  contactAddressId?: string;
}

const CustomerAddressesBox: React.FC<Props> = ({
  addresses,
  contactAddressId,
  invoiceAddressId,
}): React.ReactElement => {
  const { tCustomer } = useCustomTranslation();

  const getAddressTag = (address: CustomerPortalCustomerAddressInfo) => {
    if (addresses.length === 1) return "";

    if (address.id === contactAddressId && address.id === invoiceAddressId)
      return tCustomer("invoice_address");
    if (address.id === contactAddressId) return tCustomer("contact_address");
    if (address.id === invoiceAddressId) return tCustomer("invoice_address");

    return "";
  };

  return (
    <Box
      className="mt-8" // w-1/2 pr-2"
      title={tCustomer("addresses")}
      items={addresses.map((address) => ({
        label:
          address.name !== "" && address.name
            ? address.name
            : tCustomer("address"),
        subLabel: getAddressTag(address),
        value: oneLineAddress(address),
      }))}
    />
  );
};

export default CustomerAddressesBox;
